import React from "react";

const ItemProject = ({
  image,
  title,
  design,
  description,
  development,
  tags,
  link,
  time,
}) => {
  return (
    <div className="relative p-1 transition-all rounded-md aspect-video group bg-slate-700">
      <img
        loading="lazy"
        src={image}
        alt="project"
        className="object-cover w-full h-full"
      />
      <div className="absolute bg-[#000] bg-opacity-75 group-hover:opacity-100 opacity-0 transition-all duration-200 top-0 bottom-0 left-0 right-0 ">
        <div className="flex flex-col justify-around h-full p-5 rounded-lg ">
          <div className="flex justify-between ">
            <div className="cursor-default flex flex-col gap-[4px]">
              <h2 className="font-semibold text-[28px]">{title}</h2>
              <span className="text-xs font-light">{time}</span>
            </div>
            <a href={link} target="_blank" rel="noreferrer">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                stroke="#fff"
                xmlns="http://www.w3.org/2000/svg"
                className="cursor-pointer"
              >
                <path
                  d="M12.625 9.375L20.75 1.25M20.75 1.25H15.3333M20.75 1.25V6.66667M20.75 13.1667V18.5833C20.75 19.158 20.5217 19.7091 20.1154 20.1154C19.7091 20.5217 19.158 20.75 18.5833 20.75H3.41667C2.84203 20.75 2.29093 20.5217 1.8846 20.1154C1.47827 19.7091 1.25 19.158 1.25 18.5833V3.41667C1.25 2.84203 1.47827 2.29093 1.8846 1.8846C2.29093 1.47827 2.84203 1.25 3.41667 1.25H8.83333"
                  strokeWidth="2.16667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
          <div className="flex flex-col gap-3">
            <p className="flex flex-col gap-1 font-semibold text-green-400">
              <span>Design: {design}</span>
              <span>Development: {development}</span>
            </p>
            <span className="font-light leading-5 cursor-default">
              {description}
            </span>
          </div>
          <p className="flex gap-3 text-[#a8a8a8] ">
            {tags?.length > 0 &&
              tags?.map((item, index) => (
                <span
                  key={index}
                  className="px-2 py-1 text-sm text-white bg-slate-500"
                >
                  {item}
                </span>
              ))}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ItemProject;
